import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "@mui/styles";

// * Import lib comp
import { Box } from "@mui/material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ListRoundedIcon from "@mui/icons-material/ListRounded";
import APP_CONSTANTS from "../../../utils/config";

function ViewCardsSetting(props = {}) {
  // * Props
  const { currentView, disabled, handleViewChange } = props;

  // * Hooks
  const theme = useTheme();

  // # JSX
  return (
    <Box
      sx={{
        display: "flex",
        borderRadius: theme.size[3],
        alignItems: "center",
        background: theme.palette.tertiary.lightGrey,
        height: "fit-content",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: theme.size[3],
          padding: `0 ${theme.size[4]}`,
          cursor: "pointer",
          background:
            currentView === APP_CONSTANTS.CARD_VIEW
              ? theme.palette.primary.darkViolet
              : "",
        }}
        onClick={() => handleViewChange(APP_CONSTANTS.CARD_VIEW)}
      >
        <GridViewRoundedIcon
          sx={{
            color:
              currentView === APP_CONSTANTS.CARD_VIEW
                ? theme.palette.viewIcon.active
                : "",
            fontSize: theme.size[25],
            padding: theme.size[3],
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: theme.size[3],
          padding: `0 ${theme.size[4]}`,
          cursor: "pointer",
          background:
            currentView === APP_CONSTANTS.TABLE_VIEW
              ? theme.palette.primary.darkViolet
              : "",
        }}
        onClick={() => handleViewChange(APP_CONSTANTS.TABLE_VIEW)}
      >
        <ListRoundedIcon
          sx={{
            color:
              currentView === APP_CONSTANTS.TABLE_VIEW
                ? theme.palette.viewIcon.active
                : "",
            fontSize: theme.size[25],
            padding: theme.size[3],
          }}
        />
      </Box>
    </Box>
  );
}

export default ViewCardsSetting;
